var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3.125C9.51 3.125 2.625 10.01 2.625 18.5C2.625 26.99 9.51 33.875 18 33.875C26.49 33.875 33.375 26.99 33.375 18.5C33.375 10.01 26.49 3.125 18 3.125ZM18.69 9.65C18.96 9.65 19.185 9.875 19.185 10.16L19.02 22.25H16.98L16.815 10.16C16.815 9.89 17.04 9.65 17.31 9.65H18.675H18.69ZM18 27.35C17.145 27.35 16.425 26.645 16.455 25.775C16.425 24.92 17.16 24.23 18 24.23C18.84 24.23 19.545 24.935 19.545 25.775C19.545 26.615 18.84 27.35 18 27.35Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoWarning);
export default __webpack_public_path__ + "static/media/info_warning.8afd21e201af80a1dc5e87621c67173b.svg";
export { ForwardRef as ReactComponent };